<template>
    <div class='sp-container'>
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .sp-container {
        display: block;
        margin: 0 auto;
        max-width: 1200px;
        padding: 0 10px 0 10px;
    }
</style>


// WEBPACK FOOTER //
// SPContainer.vue?4280058c